<template>
  <section id="section-following-list">
    <div v-if="watchListCount" id="result-list">
      <div :class="[ isSticky ? 'sticky-top' : 'remove-sticky-top']">
        <nav class="nav-result">
          <ul class="nav-list">
            <li v-for="item in menuList" :key="item.title">
              <a
                data-action="open_tab"
                data-eventcategory="following_flow"
                :data-tab="item.dataTab"
                href="javascript:;"
                :class="[ currentTab == item.action ? 'active': '']"
                @click="isSelectTab(item.action)"
              >{{ item.title }}</a>
            </li>
          </ul>
        </nav>
        <div v-if="isSticky" class="bottom-line"></div>
      </div>
      <div id="header">
        <div class="title">{{title}}</div>
        <div v-if="watchlist.length" class="action">
          <a
            v-if="!isEditing"
            class="edit"
            data-action="edit_watch_list"
            data-eventcategory="following_flow"
            href="javascript:;"
            @click="toggleEdit()"
          >
            <i class="fas fa-edit"></i> Edit
          </a>
          <div v-else class="sub-action">
            <a
              class="cancel"
              href="javascript:;"
              @click="discardEdit()"
              data-action="finish_edit_watch_list"
              data-eventcategory="following_flow"
            >Cancel</a>
            <a
              class="done"
              href="javascript:;"
              @click="saveEdit()"
              data-action="finish_edit_watch_list"
              data-eventcategory="following_flow"
            >Done</a>
          </div>
        </div>
      </div>
      <Result v-if="!isEditing" :items="watchlist" :type="currentTab" :wantLoading="false" />
      <ResultEdit v-else @itemChanged="value => itemChanged = value" :items="watchlist" :type="currentTab" />
      <EmptyResult v-if="!watchlist.length" :nameThaiTab="nameTab[currentTab]" :type="currentTab" />
    </div>
    <ResultNotfound v-else />
    <toast
      v-if="toggleToast"
      :toggleToast="toggleToast"
      :status="toastStatus"
      :toastType="toastType"
      :options="options"
      @close-toast="closeToast"
      @confirm-toast="confirmToast"
    ></toast>
  </section>
</template>

<script>
import _ from "lodash/maxBy"
const ResultNotfound = () => import("../following/ResultNotfound")
const Result = () => import("../following/Result")
const EmptyResult = () => import("../following/EmptyResult")
const ResultEdit = () => import("../following/ResultEdit")
import { mapGetters, mapActions } from "vuex"
import Toast from "../../../components/miniapp/global/Toast.vue"
export default {
  components: {
    Result,
    ResultNotfound,
    ResultEdit,
    Toast,
    EmptyResult
  },
  data() {
    return {
      isSticky: false,
      isEditing: false,
      itemChanged: null,
      selectedTab: null,
      nameTab: {
        indices: "ดัชนี",
        stocks: "หุ้น",
        funds: "กองทุน",
        gold: "ทองคำ"
      },
      options: {
        dialog: {
          title: "",
          body: "คุณต้องการออกจากหน้านี้โดยไม่บันทึกข้อมูลใช่หรือไม่",
          action: [
            {
              action1: "ออกจากหน้านี้",
              action2: "อยู่ต่อ"
            }
          ]
        },
        toast: {
          title: [
            {
              success: "บันทึกข้อมูลสำเร็จ",
              unsuccess: "บันทึกข้อมูลไม่สำเร็จ"
            }
          ],
          duration: 2
        }
      },
      toastStatus: false,
      toggleToast: false,
      toastType: null,
      saveTab: null,
      menuList: [
        {
          title: "Funds",
          dataTab: "following_fund",
          action: "funds"
        },
        {
          title: "Stocks",
          dataTab: "following_stock",
          action: "stocks"
        },
        {
          title: "Indices",
          dataTab: "following_index",
          action: "indices"
        },
        {
          title: "Gold",
          dataTab: "following_gold",
          action: "gold"
        }
      ]
    }
  },
  computed: {
    ...mapGetters("watchlist", [
      "getGoldWatchlist",
      "getStockWatchlist",
      "getFundWatchlist",
      "getIndiceWatchlist",
      "getLoadingWatchlist"
    ]),
    currentTab: {
      get() {
        if (this.selectedTab) return this.selectedTab
        let obj = [
          { name: "funds", score: this.getFundWatchlist.length },
          { name: "stocks", score: this.getStockWatchlist.length },
          { name: "indices", score: this.getIndiceWatchlist.length },
          { name: "gold", score: this.getGoldWatchlist.length }
        ]
        return _(obj, "score").name
      },
      set(value) {
        this.selectedTab = value
      }
    },

    watchlist() {
      switch (this.currentTab) {
        case "stocks":
          return this.getStockWatchlist
        case "indices":
          return this.getIndiceWatchlist
        case "gold":
          return this.getGoldWatchlist
        default:
          return this.getFundWatchlist
      }
    },
    watchListCount() {
      return (
        this.getStockWatchlist.length +
        this.getIndiceWatchlist.length +
        this.getFundWatchlist.length +
        this.getGoldWatchlist.length
      )
    },
    title() {
      switch (this.currentTab) {
        case "stocks":
          return "STOCKS"
        case "indices":
          return "INDICES"
        case "gold":
          return "GOLD"
        default:
          return "MUTUAL FUNDS"
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      async handler() {
        if (this.$route.name === "miniapp-watch-list") {
          await this.findWatchlist('fund')
          await this.findWatchlist('stock')
          await this.findWatchlist('gold')
        }
      }
    }
  },
  methods: {
    ...mapActions("watchlist", ["adjustWatchlist", "findWatchlist"]),
    isSelectTab(tab) {
      // if(this.isEditing) return alert('Please save editing')
      if (this.isEditing) {
        this.saveTab = tab
        this.toastType = "confirmation"
        this.toggleToast = true
      } else {
        this.selectedTab = tab
      }
    },
    toggleEdit() {
      this.selectedTab = this.currentTab
      this.isEditing = !this.isEditing
    },
    async saveEdit() {
      if (this.itemChanged) {
        const data = {
          subjectType: "",
          subjectIDs: []
        }
        // map new data change
        this.itemChanged.forEach(item => {
          data.subjectIDs.push(item.id)
        })
        // map new fund watchlist
        if (this.currentTab == "funds") {
          data.subjectType = "fund"
        }
        // map indice watchlist
        else if (this.currentTab == "stocks") {
          data.subjectType = "stock"
          this.getIndiceWatchlist.forEach(indice => {
            data.subjectIDs.push(indice.id)
            this.itemChanged.push(indice)
          })
        }
        // map stock watchlist
        else if (this.currentTab == "indices") {
          data.subjectType = "stock"
          this.getStockWatchlist.forEach(stock => {
            data.subjectIDs.push(stock.id)
            this.itemChanged.push(stock)
          })
        }
        // map new gold watchlist
        else if (this.currentTab == "gold") {
          data.subjectType = "gold"
          data.subjectIDs = data.subjectIDs.map(gold => {
            switch (gold) {
              case 'gold-trader-ornament':
                return 'gold_ornaments'
              case 'gold-trader-bar':
                return 'gold_bar'
              case 'gold-spot':
                return 'gold_spot'
            }
          })
        }
        const adjustResult = await this.adjustWatchlist({
          subjectType: data.subjectType,
          subjectIDs: data.subjectIDs,
          itemChanged: this.itemChanged
        }) // update watchlist !!
        this.itemChanged = null // clear data change state after update to watchlist

        // show toast alert
        setTimeout(() => {
          this.toastType = "alert"
          this.toastStatus = adjustResult == true
          this.toggleToast = true
        }, 500)
      }
      this.isEditing = !this.isEditing
    },
    closeToast(bool) {
      this.toggleToast = bool
    },
    confirmToast(val) {
      if (val) {
        this.selectedTab = this.saveTab
        this.isEditing = false
        this.itemChanged = null
      }
      this.toggleToast = false
    },
    discardEdit() {
      this.isEditing = !this.isEditing
      this.itemChanged = null
    }
  }
}
</script>

<style lang="scss" scoped>
#section-following-list {
  .test-fin-col {
    width: 100%;
    background-color: red;
    .left {
      height: 50px;
      text-align: center;
      @include finCol(6, 12, 0px, middle, true, true);
    }
    .right {
      height: 50px;
      text-align: center;
      @include finCol(6, 12, 0px, middle, true, true);
    }
  }
  #result-list {
    #header {
      padding: 16px;
      border-bottom: 1px solid $color-line-grey;
      .title {
        font-weight: bold;
        color: $color-normal-text;
        @extend %font-size-m;
        @include finCol(6, 12, 0px, middle, true, true);
      }
      .action {
        text-align: right;
        @include finCol(6, 12, 0px, middle, true, true);
        .edit {
          padding: 4px;
          font-weight: normal;
          color: $color-secondary-text;
          @extend %font-size-ss;
          text-decoration: none;
          i {
            color: $color-secondary-text;
            text-align: center;
            pointer-events: none;
          }
        }
        .cancel {
          text-align: right;
          @include finRippleBtn($color-white, $color-primary-finno, $color-normal-text);
          @extend %font-size-ss;
          padding: 2px 9px;
          margin-right: 6px;
          text-decoration: none;
          font-weight: bold;
          border-radius: 14px;
          display: inline-block;
        }
        .done {
          text-align: right;
          @include finRippleBtn($color-primary-finno, $color-primary-finno, $color-normal-text);
          @extend %font-size-ss;
          padding: 2px 14px;
          text-decoration: none;
          font-weight: bold;
          border-radius: 14px;
          display: inline-block;
        }
      }
    }
    .nav-result {
      @extend %container-style;
      margin: 20px 0;
      display: inline-block;
      .nav-list {
        margin: 0;
        padding: 0;
        li {
          display: inline-block;
          margin-right: 12px;
          a {
            text-transform: uppercase;
            border-radius: 16px;
            background-color: $color-line-grey;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: $color-normal-text;
            text-decoration: none;
            padding: 5px 10px;
            width: 100%;
            max-width: 72px;
            min-width: 72px;
            display: inline-block;
            @include finRippleBtn($color-line-grey, $color-line-grey, $color-secondary-text);
          }
          .active {
            background-color: $color-normal-text;
            color: $color-white;
            font-weight: bold;
            @include finRippleBtn($color-normal-text, $color-normal-text, $color-white);
          }
        }
      }
    }
    // .content-list {
    //   text-align: center;
    //   margin: 18px 0;
    // }
    .button-list {
      @include finRippleBtn(#f9f9f9, #f9f9f9, $color-normal-text);
      @extend %font-size-ss;
      padding: 11px 25px;
      text-decoration: none;
      font-weight: bold;
      border-radius: 4px;
      display: inline-block;
      i {
        pointer-events: none;
        margin-right: 10px;
      }
    }
  }
}
</style>